var i, len, makeTag, name, ref;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  name = ref[i];
  makeTag[name] = _.partial(makeTag, name);
}

module.exports = makeTag;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL21ha2VUYWcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL21ha2VUYWcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxHQUFVLFNBQUMsSUFBRCxFQUFPLElBQVAsRUFBa0IsT0FBbEI7QUFDUixNQUFBOztJQURlLE9BQU87OztJQUFJLFVBQVU7O0VBQ3BDLElBQWlDLE9BQU8sSUFBUCxLQUFlLFFBQWhEO0lBQUEsTUFBa0IsQ0FBQyxFQUFELEVBQUssSUFBTCxDQUFsQixFQUFDLGFBQUQsRUFBTyxpQkFBUDs7RUFDQSxJQUFBLEdBQU8sR0FBQSxHQUFLO0VBQ1osSUFBQSxHQUFPLElBQUEsR0FBTSxJQUFOLEdBQVk7QUFDbkIsT0FBQSxXQUFBOztJQUNFLEdBQUEsR0FBTSxDQUFDLENBQUMsTUFBRixDQUFTLEdBQVQ7SUFDTixHQUFBLEdBQU0sQ0FBQyxDQUFDLE1BQUYsQ0FBUyxNQUFBLENBQU8sR0FBUCxDQUFUO0lBQ04sSUFBQSxJQUFRLEdBQUEsR0FBTSxHQUFOLEdBQVksSUFBWixHQUFtQixHQUFuQixHQUF5QjtBQUhuQztTQUlBLElBQUEsR0FBTyxHQUFQLEdBQWEsT0FBYixHQUF1QjtBQVJmOztBQVVWO0FBQUEsS0FBQSxxQ0FBQTs7RUFBQSxPQUFRLENBQUEsSUFBQSxDQUFSLEdBQWdCLENBQUMsQ0FBQyxPQUFGLENBQVUsT0FBVixFQUFtQixJQUFuQjtBQUFoQjs7QUFLQSxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
